import { createSlice } from '@reduxjs/toolkit';
import axios from '../../utils/axios';
import { dispatch } from '../store';

const initialState = {
    isLoading: false,
    error: null,
    notification: [],
    singlenotification: [],
};


const slice = createSlice({
    name: 'notification',
    initialState,
    reducers: {
        // START LOADING
        startLoading(state) {
            state.isLoading = true;
        },

        // HAS ERROR
        hasError(state, action) {
            state.isLoading = false;
            state.error = action.payload;
        },

        // GET Notification
        getNotification(state, action) {
            state.isLoading = false;
            state.notification = action.payload;
        },
        // GET Single Notification
        getSingleNotification(state, action) {
            state.isLoading = false;
            state.singlenotification = action.payload;
        },

    },
});
export default slice.reducer;


export function getnotification(paginate, pageIndex, pageSize) {
    return async (dispatch) => {
        dispatch(slice.actions.startLoading());
        try {
            const params = {};
            if (paginate) params.paginate = paginate;
            if (pageIndex) params.page = pageIndex;
            if (pageSize) params.per_page = pageSize;
            const response = await axios.get(`/api/admin/sendnotifications`, { params });
            dispatch(slice.actions.getNotification(response?.data?.data));
        } catch (error) {
            dispatch(slice.actions.hasError(error));
        }
    };
}

export function getsinglenotification(id) {
    return async () => {
        dispatch(slice.actions.startLoading());
        try {
            const response = await axios.get(`/api/admin/sendnotifications/${id}`);
            dispatch(slice.actions.getSingleNotification(response?.data?.data));
        } catch (error) {
            dispatch(slice.actions.hasError(error));
        }
    };
}

